/// <amd-module name="VSSUI/Components/ItemIndicator/index" />
export * from "./Item";
export * from "./ItemIndicator";
export { IItemIndicatorProps, IItemIndicatorSetProps } from "./ItemIndicator.Props";
